import { FunctionComponent, useContext } from "react"
import { Redirect, useLocation } from "react-router-dom"
import { AuthContext } from "context/context/AuthContext"
import { isRestrictedRouteForRole } from "helpers/validationRoutesHelper"
import { ResourceRoleEnum } from "enums/ResourceRoleEnum"

/**
 * Componente que verifica si el usuario tiene acceso a la ruta actual
 * Si la ruta está restringida para su rol, redirige a la ruta apropiada
 */
interface RestrictedRouteWrapperProps {
  children: React.ReactNode
}

const RestrictedRouteWrapper: FunctionComponent<RestrictedRouteWrapperProps> = ({ children }) => {
  const { state: { user } } = useContext(AuthContext)
  const location = useLocation()

  // Si no hay usuario, retornar los children (ya se maneja en PrivateRoute)
  if (!user) {
    return <>{children}</>
  }

  // Verificar si la ruta está restringida para el rol del usuario
  const isRestricted = isRestrictedRouteForRole(location.pathname, user.role)

  // Si está restringida, redirigir a la ruta apropiada según el rol
  if (isRestricted) {
    // Para usuarios contractor-source, redirigir a su dashboard específico
    if (user.role === ResourceRoleEnum["webapp-contractor-source"]) {
      return <Redirect to="/contractor/dashboard" />
    }
    
    // Fallback a dashboard principal (esto no debería ocurrir con la implementación actual)
    return <Redirect to="/dashboard" />
  }

  // Si no está restringida, renderizar los children normalmente
  return <>{children}</>
}

export default RestrictedRouteWrapper

